import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

const RegistrationError = () => {
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const [logo, setLogo] = useState(null);
    const navigate = useNavigate();
    

    useEffect(() => {
    
        const loadLogo = async () => {
          if (isHighmarkPortal) {
            const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
            setLogo(logoModule.default);
          } else {
            const logoModule = await import("./../../assets/images/win/logo-win.svg");
            setLogo(logoModule.default);
          }
        };
    
        loadLogo();
      }, [ssoData]);

  const handleTryAgainButton = () => {
    navigate(-1);
  };

  return (
      <>
        <header>
            <nav className="navbar navbar-expand-lg container-fixed">
                <a className="navbar-brand" href="#">
                    <img src={logo} alt="Logo" className="logo brand-logo" />
                </a>
            </nav>
        </header>
        <div className="registration-error-main">
            <h3 className="error-title">Whoops!</h3>
            <h5 className="error-subtitle">We're having a little trouble matching your information.</h5>
            <p className="detail">This is usually temporary and can happen if your employer's eligibility file has not updated yet, or if some details look a bit different.</p>
            <p><strong>You can try:</strong></p>
            <ul>
                <li className="detail">Entering your legal name(no nicknames)</li>
                <li className="detail">Confirming your date of birth</li>
            </ul>
            <p className="detail mb-4">If you're still unable to create your account, please call us at 855-255-7197. Our team is happy to help. We look forward to connecting with you and supporting you along your journey.</p>
            <button className="win-btn-secondary-outlined" onClick={handleTryAgainButton}>Try again</button>
        </div>
      
      </>
    )
};


export default RegistrationError;
